import { useContext } from "react";
import { AlertContext } from "./AlertProvider";

const useAlert = () => {
	const { showAlert } = useContext(AlertContext);
	return { showAlert };
};

export default useAlert;
